<template>
    <section>
        <el-row :gutter="24">
            <el-col :span="10">
                <div style="float: left; margin-right: 1px; margin-top: 5px">Range:</div>
                <el-date-picker type="date" size="small" placeholder="From date" style="width: 150px"
                                v-model="fromDate"></el-date-picker>
                -
                <el-date-picker type="date" size="small" placeholder="To date" style="width: 150px"
                                v-model="toDate"></el-date-picker>
                <el-button size="small" type="success" @click="reloadImportLogs">Update</el-button>
            </el-col>
            <el-col :span="4" :lg="6" :push="1">
                <el-upload
                        ref="upload"
                        action=""
                        :http-request="submitFile"
                        :before-upload="beforeUpload"
                        :auto-upload="false" style="float: left">
                    <el-button slot="trigger" size="small" type="primary" title="Upload csv files only!">Select File
                    </el-button>
                    <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Upload To
                        Server
                    </el-button>
                </el-upload>
            </el-col>

            <el-col :span="4" :lg="6" :push="1">
                <el-button type="text" @click="dialogTableVisible = true">How to import sales orders?</el-button>
                <SalesOrderPopup :dialogTableVisible="dialogTableVisible" @onClose="closeModal"/>
            </el-col>
        </el-row>

        <!--List-->
        <el-table :data="importLogItems" highlight-current-row v-loading="listLoading" :default-sort="sortingColumn"
                  @sort-change="handleSorting" style="width: 100%;">
            <el-table-column prop="import_date" label="Date" sortable="custom">
            </el-table-column>
            <el-table-column prop="status" label="Status" sortable="custom">
            </el-table-column>
            <el-table-column prop="requested" label="Requested">
            </el-table-column>
            <el-table-column prop="imported" label="Imported">
            </el-table-column>
            <el-table-column prop="rejected" label="Rejected">
            </el-table-column>
            <el-table-column prop="imported_file" label="Imported File">
                <template slot-scope="scope">
                    <a :href="scope.row.imported_file_url" size="small">{{scope.row.imported_file}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="log_file" label="Log File">
                <template slot-scope="scope">
                    <a :href="scope.row.log_file_url" size="small">{{scope.row.log_file}}</a>
                </template>
            </el-table-column>
        </el-table>

        <!--Панель инструментов-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="sizes, total, prev, pager, next" @current-change="handleCurrentChange"
                           @size-change="handlePageSizeChange" :page-size="20" :total="total" style="float:right;">
            </el-pagination>
        </el-col>

    </section>
</template>

<script>
    import util from '../../common/js/util'
    import SalesOrderPopup from '@/components/SalesOrderPopup'
    import {uploadFile, getImportLogs} from '../../api/api';

    export default {
        components: {
            SalesOrderPopup
        },
        data() {
            return {
                importLogs: [],
                total: 0,
                page: 1,
                size: 20,
                listLoading: false,
                fromDate: new Date(),
                toDate: new Date(),
                entityType: 'SALES_ORDER',
                sortingColumn: {
                    prop: 'import_date',
                    order: 'descending'
                },
                dialogTableVisible: false
            }
        },
        methods: {
            handleCurrentChange(val) {
                this.page = val;
                this.getLogs();
            },
            handlePageSizeChange(val) {
                this.size = val;
                this.getLogs();
            },
            handleSorting(obj) {
                console.log(obj);

                if (obj && obj.column) {
                    this.sortingColumn.prop = obj.prop;
                    this.sortingColumn.order = obj.order;
                    this.getLogs();
                }
            },
            //Get import logs
            getLogs() {
                this.listLoading = true;
                let params = {
                    page: this.page,
                    size: this.size,
                    fromDate: util.formatDate.format(new Date(this.fromDate), 'yyyy-MM-dd'),
                    toDate: util.formatDate.format(new Date(this.toDate), 'yyyy-MM-dd'),
                    column: this.sortingColumn.prop,
                    sortType: this.sortingColumn.order,
                    entityType: 'SALES_ORDER',
                };
                getImportLogs(params).then((res) => {
                    let data = res.data.data;
                    this.total = data.totalElements;
                    this.importLogs = data.items;
                    this.listLoading = false;
                });
            },
            reloadImportLogs() {
                this.getLogs();
            },
            submitFile(res) {
                let formData = new FormData();
                formData.append('uploadFile', res.file);
                formData.append('entityType', 'SALES_ORDER');

                uploadFile(formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    this.listLoading = false;
                    this.getLogs();
                }).catch(error => {
                    this.listLoading = false;
                    this.getLogs();
                });
            },
            beforeUpload() {
                this.listLoading = true;
            },
            submitUpload() {
                this.$refs.upload.submit();
            },
            closeModal() {
                this.dialogTableVisible = false;
            }
        },
        computed: {
            importLogItems() {
                let items = [];

                if (this.importLogs) {
                    for (let importLog of this.importLogs) {
                        importLog.import_date = util.formatDate.format(new Date(importLog.import_date), 'yyyy-MM-dd hh:mm');
                        items.push(importLog);
                    }
                }

                return items;
            }
        },
        mounted() {
            this.getLogs();
        }
    }

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// SalesOrderImport.vue?d7d1949e